export default __webpack_public_path__ + "static/media/login.6cfe93ce.jpg";